import React, { FC, useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import { useDependencies } from '@servicetitan/react-ioc';

import { DesktopWidget } from '../desktop-widget/desktop-widget';
import { MobileWidget } from '../mobile-widget/mobile-widget';

import { WidgetStore } from '../../stores/widget.store';

import { Device } from '../../enums/device';

import * as Styles from './widget-container.module.less';

const HEIGHT = 810;
const WIDTH = 420;

export const WidgetContainer: FC = observer(() => {
    const [{ closeWidget, showWidget, openWidget, widgetData, pageSizes, device }] =
        useDependencies(WidgetStore);

    const timeoutRef = useRef<any>();

    useEffect(() => {
        if (widgetData?.isEnabled && device !== Device.Mobile) {
            timeoutRef.current = setTimeout(() => {
                clearTimeout(timeoutRef.current);
                openWidget();
            }, 5000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [widgetData]);

    useEffect(() => {
        if (showWidget && timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }, [showWidget]);

    const scale =
        Math.floor(Math.min(pageSizes.height / HEIGHT, pageSizes.width / WIDTH) * 100) / 100;

    return (
        <div
            style={
                scale < 1 && device === Device.Desktop
                    ? { transform: `scale(${scale}, ${scale})`, transformOrigin: 'bottom right' }
                    : undefined
            }
            className={classNames({
                'h-100-i': device === Device.Mobile && showWidget,
                'p-0-i': device === Device.Mobile && showWidget,
                [Styles.wrapper]: true,
            })}
        >
            {showWidget ? device === Device.Mobile ? <MobileWidget /> : <DesktopWidget /> : null}
            <div className="d-f justify-content-end">
                <svg
                    onClick={showWidget ? closeWidget : openWidget}
                    xmlns="http://www.w3.org/2000/svg"
                    className="cursor-pointer"
                    viewBox="0 0 68 68"
                    fill="none"
                    height="68"
                    width="68"
                >
                    <g filter="url(#filter0_d_1731:73249)">
                        <circle
                            cx="34"
                            cy="30"
                            r="30"
                            fill={widgetData?.designSettings.buttonColorMask}
                        />
                    </g>
                    <rect x="22" y="18" width="24" height="19.2" rx="3" fill="white" />
                    <path
                        d="M27.3617 42L27.3617 36.6383L33.2596 36.6383L27.3617 42Z"
                        fill="white"
                    />
                    <path
                        d="M31.9999 29.4412H33.9259L33.9439 29.0992C33.9439 28.3612 34.4299 28.1812 35.1139 27.9472C36.4999 27.4612 37.5439 26.2912 37.5439 24.5452C37.5439 22.3852 35.9779 21.0352 33.8359 21.0352C31.7119 21.0352 30.0739 22.3852 30.0739 24.8512H32.2699C32.2879 23.8612 33.0439 23.2852 33.8179 23.2852C34.6639 23.2852 35.2759 23.7712 35.2759 24.6532C35.2759 25.1392 34.9879 25.6612 34.3399 25.9312L33.6919 26.1832C32.1979 26.7952 31.8559 27.6952 31.9999 29.0812V29.4412ZM32.9539 33.7612C33.7819 33.7612 34.4839 33.1492 34.4839 32.3032C34.4839 31.4572 33.7819 30.8632 32.9539 30.8632C32.1439 30.8632 31.4599 31.4572 31.4599 32.3032C31.4599 33.1492 32.1439 33.7612 32.9539 33.7612Z"
                        fill={widgetData?.designSettings.buttonColorMask}
                    />
                    <defs>
                        <filter
                            colorInterpolationFilters="sRGB"
                            filterUnits="userSpaceOnUse"
                            id="filter0_d_1731:73249"
                            height="68"
                            width="68"
                            x="0"
                            y="0"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feColorMatrix
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                                in="SourceAlpha"
                                type="matrix"
                            />
                            <feOffset dy="4" />
                            <feGaussianBlur stdDeviation="2" />
                            <feColorMatrix
                                values="0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0.1 0"
                                type="matrix"
                            />
                            <feBlend
                                result="effect1_dropShadow_1731:73249"
                                in2="BackgroundImageFix"
                                mode="normal"
                            />
                            <feBlend
                                in2="effect1_dropShadow_1731:73249"
                                in="SourceGraphic"
                                result="shape"
                                mode="normal"
                            />
                        </filter>
                    </defs>
                </svg>
            </div>
        </div>
    );
});
